module.exports = __webpack_public_path__ + "static/img/logo-media@2x.15679d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-media@2x.png
// module id = 94
// module chunks = 1